(function($) {
  $(document).ready(function() {
    console.log('document ready')

    if ($('.product-card-wrapper .card__media').length > 0) {
      $('.product-card-wrapper .card__media .media').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        infinite: false,
      })
    }
  })
})(window.jQuery)